import styled from 'styled-components'

/**
 * A common button container
 */
export const ButtonContainer = styled.div`
	margin-top: 20px;
`
